export interface SalesInvoiceValue {
  description: string;
  value: number;
}
